import api from "./api";

export const getMarketplaceBySubCategory =
    async (

        subCategoryName,

        countryCode

    ) => {

        const response = await api.get(

            `/marketplace/sub-category/${subCategoryName}`,

            {
                params: {
                    country: countryCode
                }
            }
        );

        return response.data;
    };